module.exports = __webpack_public_path__ + "static/csharp-106f8fd8c972af7ebbe965891add8de0.jpg";